import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { signIn } from "@/services/auth";
import { useCallback, useEffect, useState } from "react";

export default function Register() {
  const [cpf, setCpf] = useState("");

  const handleRegister = useCallback(async () => {
    console.log("handleRegister", cpf);

    await signIn({
      username: cpf,
      password: "",
    });
  }, [cpf]);

  useEffect(() => {
    console.log("Register");
  }, []);

  return (
    <div>
      <h1 className="">Register</h1>
      <Input
        placeholder="CPF"
        type="text"
        value={cpf}
        onChange={(e) => setCpf(e.target.value)}
        autoComplete="off"
      />
      <Button onClick={() => handleRegister()}>ENTRAR</Button>
    </div>
  );
}
